import React from "react"
import ReactApexChart from "react-apexcharts"

import { formatDate } from "helpers/helpers"

import KpiCard from "../parts/KpiCard"
import MetricHint from "../parts/MetricHint"
import {
	Card, EmptyNote, baseChartOptions, CHART_COLORS,
	convert, formatAmount, formatNumber, formatPercent, mutedStyle,
} from "../parts/common"

/** Точки: рейтинг, концентрация, география и те, кто молчит. */
function Locations({ data, currency, rates }) {
	const ranking = data.ranking || []
	const concentration = data.concentration || {}
	const byRegion = data.by_region || []
	const stale = data.stale || []

	const amount = (value) => formatAmount(convert(value, null, currency, rates), currency)

	const regionChart = {
		options: {
			...baseChartOptions,
			chart: { ...baseChartOptions.chart, type: "bar", height: 320 },
			colors: [CHART_COLORS[0]],
			plotOptions: { bar: { borderRadius: 4, horizontal: true, barHeight: "60%" } },
			xaxis: { ...baseChartOptions.xaxis, categories: byRegion.map((row) => row.region_name) },
			legend: { show: false },
		},
		series: [{ name: "Точек", data: byRegion.map((row) => row.points) }],
	}

	return (
		<>
			<div className="row g-2 mb-3">
				<div className="col-md-3">
					<KpiCard title="Точек в обороте" hintKey="metric_mal_hint"
						value={formatNumber(concentration.points)} sublabel="давали чеки за период" />
				</div>
				<div className="col-md-3">
					<KpiCard title="Оборот за период" hintKey="metric_gtv_hint"
						value={amount(concentration.total_gtv)} />
				</div>
				<div className="col-md-3">
					<KpiCard title="Доля топ-10" hintKey="metric_concentration_hint"
						value={formatPercent(concentration.top10_percent)}
						sublabel="сколько оборота дают 10 крупнейших" accent="#f0a04c" />
				</div>
				<div className="col-md-3">
					<KpiCard title="Доля топ-20" hintKey="metric_concentration_hint"
						value={formatPercent(concentration.top20_percent)} accent="#f0a04c" />
				</div>
			</div>

			<div className="row g-2 mb-2">
				<div className="col-md-5">
					<Card title="География">
						{byRegion.length === 0 && <EmptyNote>Нет данных</EmptyNote>}
						{byRegion.length > 0 && (
							<ReactApexChart options={regionChart.options} series={regionChart.series}
								type="bar" height={320} />
						)}
					</Card>
				</div>

				<div className="col-md-7">
					<Card title="Молчат" hint={<MetricHint hintKey="metric_stale_hint" />}
						right={<span style={mutedStyle}>отток начинается с тишины</span>}>
						{stale.length === 0 && <EmptyNote>Все активные точки бьют чеки — молчащих нет</EmptyNote>}
						{stale.length > 0 && (
							<div className="table-responsive" style={{ maxHeight: "320px", overflowY: "auto" }}>
								<table className="table table-sm table-hover table-bordered mb-0" style={{ fontSize: "12px" }}>
									<thead>
										<tr>
											<th>Точка</th>
											<th>Регион</th>
											<th className="text-end">Тариф</th>
											<th className="text-end">Дней молчит</th>
											<th className="text-center">Последний чек</th>
										</tr>
									</thead>
									<tbody>
										{stale.map((row) => (
											<tr key={row.pos_id}>
												<td>{row.name} <span style={mutedStyle}>· {row.login}</span></td>
												<td>{row.region_name || "—"}</td>
												<td className="text-end">{amount(row.tariff)}</td>
												<td className="text-end" style={{ color: row.days_silent > 14 ? "#d23434" : "inherit" }}>
													{row.days_silent}
												</td>
												<td className="text-center">{row.last_cheque_at ? formatDate(row.last_cheque_at, "dd.MM.yyyy") : "—"}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						)}
					</Card>
				</div>
			</div>

			<Card title="Рейтинг точек">
				{ranking.length === 0 && <EmptyNote>Нет данных за период</EmptyNote>}
				{ranking.length > 0 && (
					<div className="table-responsive">
						<table className="table table-sm table-hover table-bordered mb-0" style={{ fontSize: "12px" }}>
							<thead>
								<tr>
									<th>Точка</th>
									<th>Бренд</th>
									<th>Регион</th>
									<th className="text-end">Оборот</th>
									<th className="text-end">Чеков</th>
									<th className="text-end">Средний чек</th>
									<th className="text-end">Тариф</th>
									<th className="text-end">Баланс</th>
									<th className="text-center">Последний чек</th>
								</tr>
							</thead>
							<tbody>
								{ranking.map((row) => (
									<tr key={row.pos_id}>
										<td>{row.name}</td>
										<td style={mutedStyle}>{row.login}</td>
										<td>{row.region_name || "—"}</td>
										<td className="text-end">{amount(row.gtv)}</td>
										<td className="text-end">{formatNumber(row.cheques)}</td>
										<td className="text-end">{amount(row.avg_cheque)}</td>
										<td className="text-end">{amount(row.tariff)}</td>
										<td className="text-end" style={{ color: row.balance < 0 ? "#d23434" : "inherit" }}>
											{amount(row.balance)}
										</td>
										<td className="text-center">{row.last_cheque_at ? formatDate(row.last_cheque_at, "dd.MM.yyyy") : "—"}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</Card>
		</>
	)
}

export default Locations
